import type { UserInfoResponse } from "@/api/types";
import { getToken } from "@/lib/auth";

/** 仅依据 GetUserInfo 接口返回判断（勿读 persist store 中的 userInfo） */
export function needsForceSetPassword(
  userInfo: UserInfoResponse | null | undefined
): boolean {
  if (!getToken() || !userInfo?.uid) return false;
  return userInfo.authType === "email" && userInfo.hasPassword === false;
}
